import React, { useState, useEffect } from "react";
import {
  getData,
  getOneData,
  postData,
} from "../../../components/helpers/Data";
import { Spinner } from "../../../components/helpers/Spinner";
import MessageModal from "../../../components/helpers/Modal2";
import { userSaveDetails } from "../../../components/helpers/UserSaveDetails";

const ManageUser = () => {

  //create array for logs when renewing corp
  const logData = userSaveDetails(8);

  //module variables

  const [userGroup, setUserGroup] = useState([]);
  const [userData, setUserData] = useState([]);
  const [oneUserRowData, setOneUserRowData] = useState([]);
  const [appendedUser, setAppendedUser] = useState([]);
  const [appendedUserGroup, setAppendedUserGroup] = useState([]);
  const [addedNewUserGroup, setAddedNewdUserGroup] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [response, setResponse] = useState(false);
  const [username, setUsername] = useState([]);
  const [userGroupName, setUserGroupName] = useState([]);
  const [gender, setGender] = useState([]);

  const [visibleState, setVisibleState] = useState({
    savebtn: true,
    savebtn2: true,
  });

  //enable save
  const enableSave = (e) => {
    setVisibleState({ savebtn: false });
  };

  useEffect(() => {
    getData("fetch_gender")
      .then((data) => {
        setGender(data);
      })
      .catch((error) => console.log(error));
    getData("fetch_user_groups")
      .then((data) => {
        setUserGroup(data);
      })
      .catch((error) => console.log(error));

    document.getElementById("spinner").style.display = "block";
    getData("fetch_users")
      .then((data) => {
        setUserData(data);
        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  }, []);

  const getUserRowData = (e) => {
    setOneUserRowData([]);
    e.preventDefault();
    const arr = [];
    e.target.parentNode.parentNode.querySelectorAll("td").forEach((element) => {
      arr.push(element.children[0].value);
    });
    document.getElementById("spinner").style.display = "block";
    getOneData("fetch_user_group", arr[0])
      .then((data) => {
        setOneUserRowData(data);

        setUserGroupName(arr[0]);
        setVisibleState({ savebtn2: false });
        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  };

  // append user group row tab1
  const appendUserGroupTab1 = (e) => {
    e.preventDefault();
    const row = {
      id: new Date().getTime().toString(),
      new: (
        <>
          <td>
            <input
              className="form-control"
              type="text"
              name="user_name_appended[]"
              id="user_name_appended"
              value={userGroupName}
              readOnly
            />
          </td>
          <td>
            <select
              className="form-control-sm"
              name="user_group_appended[]"
              style={{ width: "400px" }}
            >
              <option value="">Select UserGroup</option>
              {userGroup.map((dt) => {
                return <option value={dt.code}>{dt.user_group}</option>;
              })}
            </select>
          </td>
          <td>
            <button
              className="btn text-danger btn-sm"
              onClick={(e) => removeUserGroup(row.id, e)}
            >
              <i className="fas fa-trash fa-sm"></i>
            </button>
          </td>
        </>
      ),
    };

    setAppendedUserGroup((appendedUserGroup) => {
      return [...appendedUserGroup, row];
    });
  };
  //remove user group row
  const removeUserGroup = async (id, e) => {
    e.preventDefault();
    setAppendedUserGroup((appendedUserGroup) => {
      return appendedUserGroup.filter((row) => row.id !== id);
    });
  };
  // append user group row tab2
  const addedUserGroupTab2 = (e) => {
    e.preventDefault();
    const row = {
      id: new Date().getTime().toString(),
      new: (
        <>
          <td>
            <input
              className="form-control"
              type="text"
              name="user_name_appended[]"
              id="user_name_appended"
              value={username}
              readOnly
            />
          </td>
          <td>
            <select
              className="form-control-sm"
              name="user_group_appended[]"
              style={{ width: "400px" }}
              onChange={enableSave}
            >
              <option value="" disabled selected>
                Select UserGroup
              </option>
              {userGroup.map((dt) => {
                return <option value={dt.code}>{dt.user_group}</option>;
              })}
            </select>
          </td>
          <td>
            <button
              className="btn text-danger btn-sm"
              onClick={(e) => removeNewUserGroup(row.id, e)}
            >
              <i className="fas fa-trash fa-sm"></i>
            </button>
          </td>
        </>
      ),
    };
    setAddedNewdUserGroup((addedNewUserGroup) => {
      return [...addedNewUserGroup, row];
    });
  };
  //remove user group row tab2
  const removeNewUserGroup = async (id, e) => {
    e.preventDefault();
    setAddedNewdUserGroup((addedNewUserGroup) => {
      return addedNewUserGroup.filter((row) => row.id !== id);
    });
  };

  //remove user row
  const removeUser = async (id, e) => {
    e.preventDefault();
    setAppendedUser((appendedUser) => {
      return appendedUser.filter((row) => row.id !== id);
    });
  };

  //delete user group
  const deleteUserGroup = (e) => {
    e.preventDefault();
    const frmData = new FormData();
    const arr = [];
    e.target.parentElement.parentElement.parentElement
      .querySelectorAll("td")
      .forEach((element) => {
        arr.push(element.children[0].value);
      });
    frmData.append("id", arr[0]);
    postData(frmData, "delete_user_group")
      .then((data) => {
        // return console.log(data);
        if (data[0].includes("Error")) {
          setResponse("Error deleting user group!");
          setIsMessageModal(true);
        } else {
          setResponse(data[0]);
          setIsMessageModal(true);
          e.target.closest("tr").remove();
        }
      })
      .catch((error) => console.log(error));
  };

  //Update user management
  const updateUserManagement = (e) => {
    e.preventDefault();

    const frmData = new FormData(document.getElementById("frmUpdateUser"));
    const blockCheckbox = document.querySelectorAll(".blocked");
    blockCheckbox.forEach((element) => {
      if (element.checked == true) {
        frmData.append("blocked[]", "1");
      } else {
        frmData.append("blocked[]", "0");
      }
    });
    postData(frmData, "update_user")
      .then((data) => {
        console.log(data);
        setResponse(data[0]);
        setIsMessageModal(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //save user management
  const saveUserManagement = (e) => {
    e.preventDefault();

    const frmData = new FormData(document.getElementById("frmSaveUser"));
    frmData.append("user", localStorage.getItem("username"));

    //append access log details
    frmData.append("user_id", logData[0]);
    frmData.append("accessed_item", logData[1]);
    frmData.append("browser_type", logData[2]);
    frmData.append("os_type", logData[3]);

    postData(frmData, "create_user")
      .then((data) => {
        // return console.log(data);
        setResponse(data[0]);
        setIsMessageModal(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //close message modal
  const closeMessageModal = () => {
    setIsMessageModal(false);
    if (response.includes("successfully")) {
      window.location.replace("/manage-user");
    }
  };
  return (
    <div>
      <div className="container">
        <p className="text-info h2">User Management</p>
        <hr />
      </div>
      <nav>
        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
          <button
            class="nav-link active"
            id="nav-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-home"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
          >
            UPDATE USER
          </button>
          <button
            class="nav-link"
            id="nav-profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-profile"
            type="button"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
          >
            ADD USER
          </button>
        </div>
      </nav>
      <div className="tab-content" id="nav-tabContent">
        {/*Update User tab*/}
        <div
          class="tab-pane fade show active"
          id="nav-home"
          role="tabpanel"
          aria-labelledby="nav-home-tab"
          tabindex="0"
        >
          <div className="container">
            <div className="card col-md-12">
              <form id="frmUpdateUser" onSubmit={updateUserManagement}>
                <table
                  className="table table-bordered"
                  style={{ maxHeight: "300px" }}
                >
                  <thead>
                    <tr>
                      <th>User Name</th>
                      <th>User Pass</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((dt) => {
                      return (
                        <tr>
                          <td>
                            <input
                              className="form-control"
                              type="text"
                              id="user_name"
                              name="user_name[]"
                              value={dt.user_name}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              type="password"
                              value={dt.user_pass}
                              readOnly
                            />
                          </td>

                          <td>
                            <select
                              className="form-control-sm"
                              name="status[]"
                              defaultValue={dt.status}
                            >
                              <option disabled selected value="0">
                                Select Status
                              </option>
                              <option value="1">Active</option>
                              <option value="2">Deactive</option>
                            </select>
                          </td>

                          <td className="text text-center">
                            <i
                              className="fas fa-check-circle fa-lg text-warning select"
                              onClick={getUserRowData}
                            ></i>                            
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <Spinner />

                <button
                  className="btn btn-success col-5"
                  onClick={appendUserGroupTab1}
                >
                  Add UserGroup
                </button>
                <table
                  className="table table-bordered"
                  style={{ maxHeight: "300px" }}
                >
                  <thead>
                    <tr>
                      <th hidden>Idx</th>
                      <th>User Name</th>
                      <th>User Group</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {oneUserRowData.map((dt) => {
                      return (
                        <tr>
                          <td hidden>
                            <input
                              className="form-control"
                              type="text"
                              name="user_group_id[]"
                              style={{ width: "400px" }}
                              value={dt.id}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              type="text"
                              name="user_name_row[]"
                              style={{ width: "400px" }}
                              value={dt.user_name}
                              readOnly
                            />
                          </td>
                          <td>
                            <select
                              className="form-control-sm"
                              name="user_group_row[]"
                              style={{ width: "400px" }}
                              defaultValue={dt.user_group}
                            >
                              <option value="">Select UserGroup</option>
                              {userGroup.map((dt) => {
                                return (
                                  <option value={dt.code}>
                                    {dt.user_group}
                                  </option>
                                );
                              })}
                            </select>
                          </td>
                          <td>
                            <button
                              className="btn text-danger btn-sm"
                              onClick={deleteUserGroup}
                            >
                              <i className="fas fa-trash fa-sm"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    {appendedUserGroup.map((data) => {
                      return <tr key={data.id}>{data.new}</tr>;
                    })}
                  </tbody>
                </table>
                <Spinner />
                <p>
                  <input
                    className="btn btn-info col-2"
                    type="submit"
                    value="save"
                    // hidden={visibleState.savebtn2}
                  />
                </p>
              </form>
            </div>
          </div>
        </div>
        {/*Add User tab*/}
        <div
          class="tab-pane fade"
          id="nav-profile"
          role="tabpanel"
          aria-labelledby="nav-profile-tab"
          tabindex="0"
        >
          <div className="container">
            <div className="col-md-12">
              <form id="frmSaveUser" onSubmit={saveUserManagement}>
                <div
                  className="row col-md-12 col-sm-12 pr-0 pl-0 ml-0"
                  id="step-1"
                >
                  <div className="col-md-12">
                    <div className="form-group row ml-0 ">
                      <div className="col-sm-4">
                        <input
                          type="text"
                          className="form-control validate_input"
                          name="surname"
                          id="surname"
                          placeholder="surname"
                        />
                      </div>

                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control validate_input"
                          name="first_name"
                          id="first_name"
                          placeholder="First Name"
                        />
                      </div>

                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          id="last_name"
                          placeholder="Last Name"
                        />
                      </div>
                    </div>

                    <div className="form-group row ml-0 ">
                      <div className="col-md-4">
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="email"
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          name="mobile_no"
                          id="mobile_no"
                          placeholder="mobile_no"
                        />
                      </div>
                      <div className="col-md-4">
                        <select
                          type="text"
                          className="form-control"
                          name="gender"
                        >
                          <option disabled selected value="0">
                            Select Gender
                          </option>
                          {gender.map((dt) => {
                            return <option value={dt.code}>{dt.gender}</option>;
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row ml-0">
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          name="user_group[]"
                          onChange={enableSave}
                          multiple
                        >
                          <option value="" disabled selected>
                            Select UserGroup
                          </option>
                          {userGroup.map((dt) => {
                            return (
                              <option value={dt.code}>{dt.user_group}</option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row ml-0 ">
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id="user_name"
                          name="user_name"
                          placeholder="User Name"
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="password"
                          className="form-control"
                          id="user_password"
                          name="user_password"
                          placeholder="User Password"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <p>
                  <input
                    className="btn btn-info col-2"
                    type="submit"
                    value="save"
                    hidden={visibleState.savebtn}
                  />
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/*Message modal*/}
      <MessageModal
        modalIsOpen={messageModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={<p className="text-white font-weight-bold h4">{response}</p>}
      />
    </div>
  );
};

export default ManageUser;
